import $ from 'jquery'

import Controller from 'lib/controller'
import dataProvider from 'service/data_provider'
import dispatcher from 'service/event_dispatcher'
import Router from 'service/router'
import windowView from 'shared/view/window'
import CollapsibleTextView from 'view/collapsible_text'
import NameTagsView from 'bundle/event_promotion/view/name_tags'
import ConnectButtonView from 'component/connect_button/connect_button'
import PaywallView from 'component/paywall/paywall'
import SyncView from 'view/sync_view'
import WirePostModel from 'component/wire/model'
import WirePostView from 'component/wire/wire'
import ActivityDetailsButtonStackView from 'bundle/activity_group/view/button_stack'
import CarouselView from 'view/carousel'
import GroupModel from 'component/teaser_group/model/teaser_group'
import GroupTeaserView from 'component/teaser_group/large'
import PostPhotosView from 'bundle/event_promotion/view/post_photos'
import PopoverView from 'component/popover/popover'
import ModalView from 'component/modal/modal'

const Ctrl = Controller.extend({
    initialize() {
        const activity = dataProvider.get('activity')
        const isPastActivity = activity.isPast
        const wirePostModel = new WirePostModel({
            url: Router.path('activity_group_activity_wire_index', {
                activityGroupId: activity.activityGroupId,
                activityId: activity.activityId,
            }),
        })

        this._isMobile = windowView.isMobile()
        if (dataProvider.get('currentUser')) {
            this._initCollapsibleText(windowView, this._isMobile, isPastActivity)
        }

        this._initConnectButton()

        this.buttonStackView = this.initSubview(ActivityDetailsButtonStackView, {
            el: '.js-event-button-stack',
            entityType: 'activity',
            entityId: activity.activityId,
            upgradeHandler: 'activity',
            upgradeHandlerParameters: {
                activityId: dataProvider.get('activity').activityId,
                activityGroupId: dataProvider.get('activity').activityGroupId,
            },
        })

        // Initialize all paywall triggers except attendance button
        this.$('.js-paywall').each((index, element) => {
            this.initSubview(PaywallView, {
                el: element,
                paywallType: 'activity',
                paywallEntityId: activity.activityId,
                upgradeHandler: 'activity',
                upgradeHandlerParameters: {
                    activityId: dataProvider.get('activity').activityId,
                    activityGroupId: dataProvider.get('activity').activityGroupId,
                },
            })
        })

        this.infoBlockTeaserView = this.initSubview(SyncView, {
            el: '.js-infoblock-teaser-container',
        })

        this.guestlistTeaserView = this.initSubview(SyncView, {
            el: '.js-guestlist-teaser-container',
        })

        if (activity.canSeeComments) {
            this.initSubview(WirePostView, {
                el: '.js-wire-container',
                model: wirePostModel,
            })

            wirePostModel.fetch()
        }

        this._initGroupTeaser()

        // Initialize slick.js carousel for post-activity photos for screens < 768px
        if (isPastActivity && this._isMobile) {
            this.initSubview(CarouselView, {
                el: '.js-mobile-carousel-wrapper',
            })
        }

        this.$('.js-post-photos').each((index, element) => {
            this.initSubview(PostPhotosView, {
                el: element,
                gallery: dataProvider.get('gallery'),
            })
        })

        this._initPopover()
        this._subscribe()
    },

    _initPopover() {
        // TODO INCONTENT-234: get this right
        if (!windowView.isMobile()) {
            this.$('.js-masked-text-post').each((i, element) => {
                this.initSubview(PopoverView, {
                    el: element,
                    content:
                        'For privacy protection, this content is only visible to members. Log in or join ' +
                        'now for free to see it too.',
                    preset: 'tooltip',
                })
            })
        }
    },

    _subscribe() {
        dispatcher.on('printNameTags:init', this._initNameTags.bind(this))
        if (this.buttonStackView) {
            this.buttonStackView
                .on('attendance:update', this.guestlistTeaserView.update)
                .on('attendance:update', this.infoBlockTeaserView.update)
        }
    },

    _initCollapsibleText(windowView, isMobile, isPastActivity) {
        const collapsibleTextOptions = {
            el: '.js-collapse-activity-description',
            collapseHeight: '115',
            collapseSpeed: '200',
        }

        if (isPastActivity) {
            Object.assign(collapsibleTextOptions, {
                el: '.js-collapse-post-activity-description',
            })
        }

        this.initSubview(CollapsibleTextView, collapsibleTextOptions)
    },

    _initNameTags(event, element) {
        this.initSubview(NameTagsView, {
            el: element,
        })
    },

    _initConnectButton() {
        $('.js-connect-button').each((index, element) => {
            this.initSubview(ConnectButtonView, { el: element })
        })
    },

    _initGroupTeaser() {
        this.$('.js-activity-group-teaser').html(
            this.initSubview(GroupTeaserView, {
                model: new GroupModel(dataProvider.get('activityGroup')),
                imageLinkRef: 'adp_he_gt',
                titleLinkRef: 'adp_he_gt',
            }).render().el
        )
    },
})

export default new Ctrl()
